import React from "react";
import { object, string } from 'yup';
import { isEmpty } from "lodash";
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";

import Header from "../../header/header";
import LabelInput from "../../uiComponent/inputs/labelInput";
import Button from "../../uiComponent/button/index";

import { AuthWrapper } from "../style";

import { setField, SendVerificationEmail } from "../../../slices/auth"

const ForgetPassword = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { sendVerificationEmailLoading } = useSelector(state => state?.auth || {});

  const handleForgetPassword = async (values) => {
    const { email } = values;
    if (isEmpty(email)) return;
    const user = {
      email
    }
    const response = await dispatch(SendVerificationEmail({ user, type: 'reset-password' })).unwrap();
    if (!response.error) {
      dispatch(setField({
        module: 'user',
        field: 'email',
        value: email
      }));
      navigate("/auth/password-email-verification");
    }
  }

  const schema = object().shape({
    email: string().email('Invalid Email').required('Email is required!')
  });

  return (
    <AuthWrapper>
      <Formik
        validationSchema={schema}
        onSubmit={(values) => handleForgetPassword(values)}
        initialValues={{
          email: '',
        }}
      >
        {({
          handleSubmit,
          handleChange,
          handleBlur,
          values,
          errors
        }) => (
          <Form onSubmit={handleSubmit}>
            <Header login={true} />
            <div className="auth-container-overlay-wrapper">
              <div className="auth-container">
                <div className="bg-albaster">
                  <div className="py-40 pt-0">
                    <div className="mb-35">
                      <h2>Enter your Registered Email Address</h2>
                    </div>
                    <LabelInput
                      inputStatus={errors.email}
                      name='email'
                      value={values.email}
                      label="Email"
                      placeholder="Email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <div className="mt-40">
                      <Button
                        type="submit"
                        disabled={sendVerificationEmailLoading}
                        text={sendVerificationEmailLoading ? "Sending Verification Email..." : "Send Email"}
                        className="primary w-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </AuthWrapper>
  );
};

export default ForgetPassword;
